<script>
import Panel from '@/components/ui/Panel';
import latinize from 'latinize';

export default {
  name: 'AnchorPanel',
  components: {
    Panel
  },
  data() {
    return {
      editor: {},
      bookmark: null,
      anchor: null,
      name: ''
    };
  },
  methods: {
    show(options) {
      const editor = options.editor;
      const el = editor.getSelectedElement();
      this.bookmark = editor.getBookmark();
      this.editor = editor;
      this.anchor = el.closest('a[id]');

      if (this.anchor) {
        this.name = this.anchor.id || this.anchor.name || '';
      } else {
        // Guess a name based on the first five words of the selected content
        this.name = el.textContent
          .split(' ')
          .slice(0, 5)
          .join(' ');
        this.handleNameChange();
      }

      this.$refs.panel.show();
    },

    hide() {
      this.$refs.panel.hide();
      this.anchor = null;
      this.name = '';
    },

    deleteAnchor() {
      this.$refs.panel.hide();
      this.editor.restoreBookmark(this.bookmark);
      this.editor.removeElement(this.anchor);
    },

    handleNameChange() {
      this.name = latinize(this.name)
        .trim()
        .toLowerCase()
        .replace(/[^a-z-0-9-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },

    handleHide() {
      this.editor.focus();
    },

    handleShow() {
      this.$refs.name.focus();
    },

    handleSubmit() {
      const name = this.name;

      this.$refs.panel.hide();
      this.editor.restoreBookmark(this.bookmark);
      this.editor.insertAnchor(name);
    }
  }
};
</script>

<template>
  <panel
    ref="panel"
    :title="$t('Anchor')"
    @show="handleShow"
    @hide="handleHide"
  >
    <el-form
      label-position="top"
      novalidate
      @submit.native.prevent="handleSubmit"
    >
      <fieldset>
        <el-form-item :label="$t('Name')">
          <el-input
            ref="name"
            v-model="name"
            type="text"
            clearable
            prefix-icon="el-icon-fa-bookmark"
            auto-complete="off"
            spellcheck="false"
            @change="handleNameChange"
          />
          <div class="text-form-description">
            {{ $t('Provide a short and descriptive name for the anchor.') }}
          </div>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-button type="primary" native-type="submit">
              <span v-if="anchor">{{ $t('Update Anchor') }}</span>
              <span v-else>{{ $t('Insert Anchor') }}</span>
            </el-button>
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button v-if="anchor" :title="$t('Delete Anchor')" @click="deleteAnchor">
              <i class="el-icon-fa-trash" />
            </el-button>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
  </panel>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//
</style>
